<template>
    <div>
        <span class="blog-txt-details">Compartir:</span>
        <share-it 
            :url="getUrl()"
            :text="getMetaDescription()"
            :share-config="iconConfig" 
            icons outline round />
    </div>
</template>

<script>
export default {
    data(){
        return{
            publicationData: null,
            iconConfig: {
                twitter: {
                    icon: true,
                    size: "sm",
                    color: "#F9A13B",
                    round: true,
                    backgroundColor: "white",
                },
                facebook: {
                    icon: true,
                    size: "sm",
                    color: "#F9A13B",
                    round: true,
                    backgroundColor: "white",
                },
                linkedin: {
                    icon: true,
                    size: "sm",
                    color: "#F9A13B",
                    round: true,
                    backgroundColor: "white",
                },
            }
        }
    },
    methods:{
        getUrl(){
            return window.location.href
        },
        getMetaDescription(){
            let meta = document.querySelector('meta[name="description"]')
            return meta ? meta.content : ''
        }
    }
}
</script>

<style lang="scss">
    .icon-border{
        border: 1px solid #F9A13B !important;
    }
</style>